export default "__VITE_ASSET__BDYydXjP__"